export enum UserType {
  COMPANY_USER = "CompanyUser",
  COMPANY_ADMIN = "CompanyAdmin",
  VENDOR_USER = "VendorUser",
  VENDOR_ADMIN = "VendorAdmin",
  TRAINER = "Trainer",
  EMPLOYEE = "Employee",
}
export enum UserRoleName {
  SUPERADMIN = "SUPERADMIN",
  COMPANY_ADMIN = "COMPANYADMIN",
  VENDOR_ADMIN = "VENDORADMIN",
  CORPORATE_ADMIN='CORPORATEADMIN',
  TRAINER = "TRAINER",
  EMPLOYEE = "Employee",
  HEAD_OF_DEPARTMENT  = "DEPARTMENTHEAD",
}
export interface ILoginResponse {
  token: string;
  isApprovedVendor?: boolean,
  refreshToken: string;
  roles: [string];
  roleName: UserRoleName;
  colors: any;
  smsSettings: any;
  smtpSettings: any;
  companyId: string;
  user: {
    userType: UserType;
    companyDepartmentId: string;
    companyDepartment: any;
    languageCode: number;
    id: string;
    userName: string;
    email: string;
  };
}

export interface Result {
  ID: number;
  FirstName: string;
  Password: null;
  FatherName: string;
  FamilyName: string;
  Username: null;
  UserTypeID: number;
  JobFamilyID: number;
  JobPositionID: number;
  BusinessEmail: string;
  Phone: string;
  ClientID: number;
  JobPosition: null;
  JobFamily: null;
  DivisionID: number;
  Division: null;
  DepartmentID: number;
  Department: null;
  LocalAdmin: boolean;
  LocalUser: boolean;
  ClientAdmin: string;
  EmployeeID: string;
  IsArabic: boolean;
  PartnerID: string;
  UserGUID: null;
  Trainer: boolean;
  superAdmin: boolean;
  SubscriberId: number;
  SubscriberName: string;
  AccessToken: string;
  RefreshToken: string;
}
